export default __webpack_public_path__ + "static/media/Cars_26.92836ac6.png";